<template>
  <div
    class="menu tab_bg"
    :class="activeSel ? 'uibg' : ''"
    style="width: 100%; padding: 0px 10px"
  >
    <Scene
      :key="1"
      v-if="changeOver"
      @localDatasave="localDatasave"
      @setT9video="setT9video"
      @cleanLocal="cleanLocal"
      @showSceneChange="showSceneChange"
      @timelineto="timelineto"
      @successedit="successedit"
      @successAdd="successAdd"
      @selector="selector"
      :t9video="t9video"
      ref="Scene"
    >
    </Scene>
    <!-- 此处代码用来做时间条管理组件，组件为t9ruler.vue文件 -->
    <div
      style="
        display: none;
        position: fixed;
        height: 300px;
        bottom: 0px;
        z-index: 9999;
        background: #ccc;
        left: 0;
      "
    >
      <div class="timeline-top" style="font-size: 24px; padding: 10px">
        时间条管理
      </div>
      <div class="timeline" style="width: 100%">
        <div class="timeline-hd">
          <div class="timeline-hd-inner" style="display: flex">
            <div class="timeline-hd-inner-left" style="width: 15%">
              时间刻度
            </div>
            <div
              class="timeline-hd-inner-right"
              style="width: 85%; background-color: red"
            >
              <t9ruler
                @post-NumValue="rulerNum"
                :NowNum="0"
                :minNum="0"
                :numSize="5"
                :ruleWidth="200"
                :pointerColor="'rgb(92, 212, 171)'"
                @scroll-end="endEvent"
                @scroll-start="startEvent"
              >
              </t9ruler>
            </div>
          </div>
          <div
            class="timeline-hd-inner"
            v-for="item in t9video.videoobj.scenes[scenes].res"
            :key="item.resid"
          >
            {{ item.resname }}
          </div>
        </div>
        <div class="timeline-bd"></div>
      </div>
    </div>

    <loading
      loader="dots"
      :active="actionLoading"
      background-color="#000"
      color="#e0a2aa"
      :width="200"
      :height="200"
    >
      <img src="@/assets/images/20130527034916434.gif" alt="" />
    </loading>

    <div
      class="rolelist rolelistSelf"
      id="rolelist"
      v-show="activeSel == 'aibobao' || activeSel == 'jiqiren'"
    >
      <ul v-show="activeSel == 'aibobao'" class="rolelist-row">
        <li @click="changeTab(0)" :class="{ check: tab == 0 }">AI脚本</li>
        <li @click="changeTab(2)" :class="{ check: tab == 2 }">历史脚本</li>
        <li @click="changeTab(1)" :class="{ check: tab == 1 }">商品管理</li>
        <li @click="openTime()" :class="{ check: tab == 3 }">测试</li>
      </ul>
      <div
        v-show="activeSel == 'aibobao'"
        class=""
        style="
          position: relative;
          width: 100%;
          height: calc(100% - 50px);
          z-index: 9;
        "
      >
        <div
          class="tab-face content-box"
          v-show="tab == 0"
          style="height: 100%"
        >
          <!--进度条控制-->
          <div class="slider" style="padding-right: 20px">
            <div class="playdiv zhujindu">
              <div class="playdiv_btn">
                <i
                  v-if="gaile"
                  @click="restart()"
                  class="iconfont icon-shuaxin"
                ></i>
                <i
                  v-if="!gaile && autoplay == false"
                  @click="start()"
                  class="iconfont icon-weibiaoti518"
                ></i>
                <i
                  v-if="!gaile && autoplay == true"
                  @click="stop()"
                  class="iconfont icon-weibiaoti519"
                ></i>
              </div>
              <div class="playdiv_slider">
                <vue-slider
                  v-model="jindutiao"
                  :tooltip="'none'"
                  @change="updateOption()"
                  :duration="0.1"
                  :lazy="true"
                  :interval="0.01"
                  :min="0"
                  :max="duration"
                  key=""
                  :dot-style="{
                    marginTop: '-30px',
                    backgroundColor: 'red',
                    border: '0',
                    width: '1px',
                    borderRadius: 0,
                    height: '1000px',
                  }"
                  :process-style="{ backgroundColor: 'pink' }"
                >
                </vue-slider>
              </div>
              <div class="playdiv_time">{{ alltime }}</div>
              <div
                v-if="false"
                :class="progressshow ? 'playdiv_menu active' : 'playdiv_menu'"
                @click="progressshow = !progressshow"
              >
                <i class="iconfont icon-jinduguanli"></i>
              </div>
            </div>

            <div class="zijindu" v-show="progressshow">
              <div
                :class="res_index == i ? 'playdiv active' : 'playdiv'"
                v-for="(ires, i) in t9video.videoobj.scenes[scenes].res"
                :key="i + 'res2'"
              >
                <div class="playdiv_btn"></div>
                <div class="playdiv_slider" v-if="zijindus[i] && false">
                  <vue-slider
                    v-model="zijindus[i].startend"
                    :tooltip="'none'"
                    @change="zijinduOption(ires, i)"
                    :hide-label="true"
                    :interval="0.01"
                    :min="0"
                    :max="duration"
                    :dot-options="ires.dotOptions"
                    :enable-cross="false"
                    :lazy="true"
                    :dot-style="{
                      backgroundColor: '#fff',
                      borderColor: 'pink',
                    }"
                    :process-style="{ backgroundColor: 'pink' }"
                    :step-style="{
                      backgroundColor: '#fff',
                      borderColor: 'pink',
                    }"
                    :step-active-style="{
                      backgroundColor: '#fff',
                      borderColor: 'pink',
                      boxShadow: '0 0 0 2px pink',
                    }"
                  ></vue-slider>
                </div>
                <div class="playdiv_time"></div>
                <div class="playdiv_menu"></div>
              </div>
            </div>
          </div>
          <!--元素菜单(已抽离出至场景组件scene/index.vue)-->

          <!--事件列表-->
          <div class="autolist" style="height: 88%">
            <div
              style=""
              v-for="(item, i) in t9video.videoobj.scenes[0].res"
              :key="i + 'ttsG'"
            >
              <div v-if="item.restype == 3" style="padding: 5px 10px">
                <span
                  style="
                    display: block;
                    font-size: 18px;
                    font-weight: 700;
                    margin-bottom: 10px;
                  "
                  >脚本大纲:</span
                >

                <div class="title">
                  <span v-if="item.restype == 3"
                    >商品:{{ item.timeline.length }}件</span
                  >
                </div>
                <div
                  class="videotext"
                  v-for="(tts, i) in item.timeline"
                  :key="i + 'ttg'"
                >
                  <!-- <span
                      :class="scenesindex == i && tts.type != 4 ? 'active' : ''"
                    > -->
                  <span :class="isplayingGoodId == tts.id ? 'active' : ''">
                    <i class="iconfont icon-shangyong icon"></i>
                    <span>《{{ tts.textname }}》</span>
                    <!-- <span v-else @click="ttsplay(i)">{{ tts.text }}</span> -->
                  </span>
                  <div class="videotext_btn">
                    <!-- 编辑时长 -->
                    <!-- <span
                      ><input
                        v-model.number="tts.dur"
                        type="number"
                        @blur="durblur"
                      />
                      s |
                    </span> -->
                    <span v-if="tts.type != 4" @click="editTts(item, tts)">
                      <i class="iconfont icon-bianji"></i>
                      编辑
                    </span>
                    <span v-if="tts.type != 4" @click="ttsdel(i)"
                      ><i class="iconfont icon-remove-1-copy"></i> 删除</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div
              style=""
              v-for="(item, i) in t9video.videoobj.scenes[0].res"
              :key="i + 'ttsR'"
            >
              <div
                style="padding: 5px 10px; margin-top: 10px"
                v-if="item.timeline.length > 0 && item.restype == 1"
              >
                <div class="title">
                  <span>人物:</span>
                  <span v-if="item.restype != 3"> {{ item.resname }}</span>
                </div>
                <draggable
                  v-model="item.timeline"
                  handle=".icon."
                  chosen-class="chosen"
                  ghost-class="ghost"
                  @end="dragEnd"
                >
                  <div
                    class="videotext"
                    v-for="(tts, i) in item.timeline"
                    :key="i + 'tt'"
                  >
                    <span :class="isplayingSpeekId == tts.id ? 'active' : ''">
                      <i
                        class="iconfont icon-test-108 icon"
                        v-if="tts.type == 1"
                      ></i>
                      <i
                        class="iconfont icon-weizhi icon"
                        v-if="tts.type == 2 || tts.type == 3"
                      ></i>
                      <i
                        class="iconfont icon-yundongdaka_ticao icon"
                        v-if="tts.anim && (tts.anim.materialId || tts.anim.key)"
                      ></i>
                      <span @click="ttsplay(i)">{{ tts.text }}</span>
                    </span>
                    <div class="videotext_btn">
                      <!-- 编辑时长 -->
                      <!-- <span
                      ><input
                        v-model.number="tts.dur"
                        type="number"
                        @blur="durblur"
                      />
                      s |
                    </span> -->
                      <span v-if="tts.type != 4" @click="editTts(item, tts)">
                        <i class="iconfont icon-bianji"></i>
                        编辑
                      </span>
                      <span v-if="tts.type != 4" @click="ttsdel(i, tts)"
                        ><i class="iconfont icon-remove-1-copy"></i> 删除</span
                      >
                    </div>
                  </div>
                </draggable>
              </div>
            </div>

            <!--事件菜单(已抽离出至场景组件scene/index.vue)-->
            <div class="element_menu" style="display: none">
              <div v-if="menu == 1" class="menuicon" @click="visible = true">
                <i class="iconfont icon-test-108"></i> 讲话
              </div>
              <!-- <div v-if="menu==1" class="menuicon"><i class="iconfont icon-yundongdaka_ticao"></i> 动作</div> -->
              <div
                class="menuicon"
                @click="elementposition()"
                v-if="menu != 'subtitle' && menu != '3'"
              >
                <i class="iconfont icon-weizhi"></i> 位置
              </div>
              <div
                class="menuicon"
                @click="shuxing = !shuxing"
                v-if="menu == 'subtitle' || menu == '3'"
              >
                <i class="iconfont icon-gantanhao"></i> 属性
              </div>
            </div>

            <div
              v-if="
                false &&
                t9video.videoobj.scenes[0].res[res_index] &&
                item.timeline.length == 0 &&
                t9video.videoobj.scenes[0].res[res_index].restype <= 2
              "
              style="text-align: center; padding: 20px 10px"
            >
              <!-- 点击☝️功能键可增加动画事件 -->
            </div>
            <!-- 商品组件 -->
            <tab-commodity
              @getscens="getscens"
              @setScene="setScene"
              v-if="shuxing && menu == 3"
              ref="tabCommodity"
              :t9video="t9video"
              :width="100"
              :isAilive="true"
            ></tab-commodity>
            <!-- 字幕组件 -->
            <tab-subtitle
              @getscens="getscens"
              @setScene="setScene"
              v-else-if="shuxing && menu == 'subtitle'"
              ref="tabSubtitle"
              :t9video="t9video"
              :width="100"
              :isAilive="true"
            ></tab-subtitle>
          </div>
        </div>
        <!-- 商品管理 -->
        <div
          class="tab-face content-box"
          style="overflow: hidden; height: 100%"
          v-show="tab == 1"
        >
          <div class="goodsList" v-if="isPaid_m()">
            <div class="title">
              <strong>商品管理</strong>
              <div class="btn">
                <button @click="getJs">生成播报脚本</button>
              </div>
              <!-- <div class="btn">
              <button @click="selector_scene_show = true">选择直播场景</button>
            </div> -->
            </div>
            <div class="tool">
              <div class="selAll">
                <input
                  type="checkbox"
                  id="checkbox"
                  v-model="allChecked"
                  @change="changeAllChecked()"
                />
                全选
              </div>
              <div class="btn">
                <span @click="addGoods()"
                  ><i class="iconfont icon-out-column"></i>添加商品</span
                >
              </div>
            </div>
            <div
              style="text-align: center; padding-top: 100px"
              class="chatnull"
              v-if="goodsList.length == 0"
            >
              暂无商品信息<br />
              <br />
              <button @click="addGoods()">新增商品</button><br /><br />
            </div>
            <div
              v-if="goodsList.length > 0"
              style="overflow-y: auto; height: 630px"
            >
              <div
                v-for="item in goodsList"
                :key="item.commodityId"
                class="goodsDetail_row"
              >
                <div class="goodsSel">
                  <!-- @change="selChange(item.commodityId)" -->
                  <input
                    type="checkbox"
                    :value="item"
                    v-model="checkedIds"
                    name=""
                    id=""
                  />
                </div>
                <div class="goodsImg">
                  <img
                    :src="
                      spileUrl(item.productCover)
                        ? spileUrl(item.productCover)
                        : require('@/assets/images/defalut.png')
                    "
                    @error="errorImg"
                    alt=""
                  />
                </div>
                <div class="goodsContent">《{{ item.commodityName }}》</div>
                <div class="goodsFun">
                  <div class="edit_del">
                    <span
                      @click="addGoods(item.commodityId)"
                      class="iconfont icon-bianji"
                    ></span>
                    <span
                      @click="delGoods(item.commodityId)"
                      class="iconfont icon-remove-1-copy"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="goodsList" v-else>
            <div class="title">
              <strong>商品管理</strong>
            </div>
            <div class="tool">
              <span>本功能为VIP功能,您还不是VIP,请联系下方微信升级:</span>
            </div>
            <div style="margin-left: 150px">
              <img src="https://t-9.cn/images/k.png" alt="" width="200px" />
            </div>
          </div>
        </div>
        <!-- 历史脚本 -->
        <div
          class="tab-face content-box"
          style="overflow: hidden; height: 100%"
          v-show="tab == 2"
        >
          <div class="goodsList">
            <div class="title">
              <strong>历史脚本</strong>
              <button v-if="historyIdActive" @click="editVideo">
                保存当前脚本
              </button>
            </div>

            <div
              class="list"
              style="
                width: 100%;
                /* height: calc(100% - 20px); */
                height: 660px;
                overflow-y: auto;
                cursor: pointer;
              "
            >
              <div
                v-for="(item, i) in historyScript"
                :key="i"
                @click="setHistoryScene(item)"
                class="list-item-title goodsDetail"
                :class="{ active: historyIdActive == item.videoId }"
              >
                <div
                  v-if="!item.videoCover"
                  :style="{
                    backgroundImage:
                      'url(' + require('@/assets/images/defalut.png') + ') ',
                    backgroundColor: '#f6f6fb',
                    backgroundSize: 'cover',
                  }"
                  style="
                    width: 100%;
                    height: 160px;
                    background-size: auto 100%;
                    background-position: center;
                  "
                ></div>

                <div
                  v-else
                  :style="{
                    backgroundImage: 'url(' + spileUrl(item.videoCover) + ') ',
                  }"
                  style="width: 100%; height: 160px; background-size: cover"
                ></div>
                <span class="goodsDetailname">{{ item.videoName }}</span>
                <div class="goodsDetaildel">
                  <span
                    @click.stop="delHistory(item.videoId)"
                    class="iconfont icon-remove-1-copy"
                  ></span>
                </div>
              </div>
              <div
                v-for="i in 2"
                :key="i + 'i'"
                style="width: 30%; height: 0"
              ></div>
            </div>
            <pagination
              v-if="historyScript.length > 0"
              class="pull-right paginationAuto"
              :paginationOpt="Pagination"
              @switchPage="employeePagesFn"
              style=""
            />
          </div>
        </div>
      </div>

      <div
        v-show="activeSel == 'jiqiren'"
        class="rightAuto"
        style="width: 100%; height: 100%"
      >
        <ul v-show="activeSel == 'jiqiren'" class="rolelist-row">
          <li @click="Jtab = 0" :class="{ check: Jtab == 0 }">智能机器人</li>
          <li @click="Jtab = 1" :class="{ check: Jtab == 1 }">自动回复</li>
        </ul>
        <div class="tab" style="z-index: 1">
          <div
            class="chatlist"
            style="z-index: 0; margin-top: 20px; height: calc(100% - 20px)"
            v-if="Jtab == 0"
          >
            <div class="chatlist_title">
              <div>实时会话</div>
              <div style="width: 120px" class="chatlist_title">
                机器人
                <toggle-switch
                  :checked="autochat"
                  @change="switchOuto"
                ></toggle-switch>
              </div>
            </div>
            <div style="" class="save-liverurl">
              <span>直播间地址:</span>
              <input @change="saveLiverUrl" v-model.trim="LiverUrl" class="" />
              <!-- <button v-if="opLiveing" @click="disconnect">关闭监听</button> -->
              <button v-if="opLiveing" @click="disconnect">关闭监听</button>
              <button v-else @click="livestart">打开监听</button>
            </div>

            <div
              class="chatqa"
              style="height: calc(100% - 130px)"
              v-if="qalist.length > 0 || opLiveing"
            >
              <div class="qainfo" v-for="(qa, i) in qalist" :key="i + 'qa'">
                <div class="qainfo_q"><span>Q</span>问题:{{ qa.q }}</div>
                <div class="qainfo_a">
                  <span>A</span>回答：{{ qa.a ? qa.a : "暂未回答" }}
                </div>
              </div>
            </div>
            <div class="chatnull" v-else>
              <i class="iconfont icon-IMliaotian-duihua"></i><br />
              暂无会话<br />
              <br />
              <button @click="livestart">启动监听直播间</button><br /><br />
              <a
                v-if="!electron"
                style="color: #39f"
                href="https://f1.t-9.cn/package/t9_live.zip"
                target="_blank"
                >下载客户端</a
              ><br />
            </div>

            <div class="AIhuihua">
              <div class="chatinput">
                <input
                  v-model="chattext"
                  type="text"
                  placeholder="请输入要对虚拟人说的话"
                  @keydown.enter="chatsend"
                />
                <i class="iconfont icon-IMliaotian-duihua"></i>
                <!-- <button @click="addqalist">发送</button> -->
                <button @click="chatsend">发送</button>
                <div v-if="chatboting" class="sikaozhong"></div>
              </div>
            </div>
          </div>
          <!-- 常见问题 -->
          <div
            class="tab-face content-box"
            style="overflow: hidden; height: 100%"
            v-if="Jtab == 1"
          >
            <div class="goodsList">
              <div class="title">
                <strong>常见问题</strong>
                <div
                  class="btn"
                  style="font-size: 14px; color: #4199fe; cursor: pointer"
                >
                  <span @click="questionShow = true"
                    ><i class="iconfont icon-out-column"></i>添加问题</span
                  >
                </div>
              </div>
              <!-- <div class="tool" style="flex-direction: row-reverse">
            <div class="btn">
              <span @click="questionShow = true"
                ><i class="iconfont icon-out-column"></i>添加问题</span
              >
            </div>
          </div> -->
              <div v-if="questionList.length == 0">
                <br /><br />
                <center>暂无问题</center>
                <br /><br />
                <center style="color: #999">
                  此处设置的问答会用于访客提问自动回答
                </center>
              </div>
              <div
                v-if="questionList.length > 0"
                style="overflow-y: auto; height: calc(100% - 20px)"
              >
                <div v-for="item in questionList" :key="item.questionId">
                  <div class="videotext quest_list">
                    {{ item.questionName }}
                    <div class="quest_editDel">
                      <span
                        @click="questionEdit(item)"
                        class="iconfont icon-bianji"
                        >编辑</span
                      >

                      <span style="margin: 0 5px"> | </span>
                      <span
                        @click="questionDel(item)"
                        class="iconfont icon-remove-1-copy"
                        >删除</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--合成音频-->
    <compose
      :visible.sync="visible"
      :moxing="autoUser"
      :t9render="t9render"
      @backfun="successcompose"
    ></compose>

    <!--挂件选择器-->
    <PendantSelector
      v-if="guajiansel"
      :user="autoUser"
      :t9render="t9render"
      @backfun="successguajian"
    ></PendantSelector>
    <!-- 设置商品弹窗 -->
    <TDialog
      top="0"
      :visible.sync="goodsShow"
      width="45%"
      title="新增商品"
      @close="cancel"
    >
      <!-- 使用v-slot指定插槽进行编辑 -->
      <div class="add-box addform_box">
        <div class="add-content">
          <div class="setup_content" @focusout="validate">
            <div class="setup_box">
              <div class="setup_lable">商品名称:</div>
              <div class="setup_block">
                <input
                  v-model="goodDetail.commodityName"
                  prop="commodityName"
                  type="text"
                  placeholder="请输入商品名称"
                  :style="{
                    border: validatorControl.commodityName
                      ? '1px solid red'
                      : '1px solid #ddd',
                  }"
                />
                <div
                  style="
                    position: absolute;
                    font-size: 12px;
                    color: red;
                    line-height: normal;
                  "
                  v-if="validatorControl.commodityName"
                >
                  {{ validatorControl.commodityName }}
                </div>
              </div>
            </div>
            <div class="setup_box">
              <div class="setup_lable">商品编号:</div>
              <div class="setup_block">
                <input
                  v-model="goodDetail.commodityNumber"
                  type="text"
                  placeholder="请输入商品编号"
                />
              </div>
            </div>
            <div class="setup_box">
              <div class="setup_lable">商品价格:</div>
              <div class="setup_block">
                <input
                  v-model="goodDetail.commodityPrice"
                  prop="commodityPrice"
                  :style="{
                    border: validatorControl.commodityPrice
                      ? '1px solid red'
                      : '1px solid #ddd',
                  }"
                  type="text"
                  placeholder="0"
                />

                <div
                  style="
                    position: absolute;
                    font-size: 12px;
                    color: red;
                    line-height: normal;
                  "
                  v-if="validatorControl.commodityPrice"
                >
                  {{ validatorControl.commodityPrice }}
                </div>
              </div>
            </div>
            <div v-if="false">
              商品解说:
              <label for="ai">
                <input
                  type="radio"
                  value="1"
                  v-model="goodDetail.commodityInterpretationType"
                  id="ai"
                />Ai解说
              </label>
              <label for="man">
                <input
                  type="radio"
                  value="2"
                  v-model="goodDetail.commodityInterpretationType"
                  id="man"
                />真人解说
              </label>
              <label for="video">
                <input
                  type="radio"
                  value="3"
                  v-model="goodDetail.commodityInterpretationType"
                  id="video"
                />视频
              </label>
            </div>
            <div class="setup_box">
              <div class="setup_lable">解说文本:</div>
              <div class="setup_block">
                <textarea
                  :style="{
                    border: validatorControl.commodityCommentary
                      ? '1px solid red'
                      : '1px solid #ddd',
                  }"
                  v-model="goodDetail.commodityCommentary"
                  prop="commodityCommentary"
                  class="longText"
                  style="resize: none"
                  rows="4"
                  maxlength="250"
                ></textarea>
                <span>{{ goodDetail.commodityCommentary.length }}/250</span>
                <div
                  style="
                    position: absolute;
                    font-size: 12px;
                    color: red;
                    line-height: normal;
                  "
                  v-if="validatorControl.commodityCommentary"
                >
                  {{ validatorControl.commodityCommentary }}
                </div>
              </div>
            </div>
            <div class="setup_box fengmian">
              <div class="setup_lable">商品图片/视频:</div>
              <div
                class="setup_block"
                style="
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: space-between;
                  width: 79%;
                "
              >
                <div
                  v-for="(item, i) in goodDetail.productCover"
                  :key="'p' + i"
                  class="uploader_img"
                >
                  <div class="tab_houzhui">
                    <span>{{ dongtai(item) }}</span>
                  </div>
                  <img
                    @error="errorImg"
                    style="width: 100%; height: 100%; object-fit: cover"
                    :src="item"
                    alt=""
                  />
                  <span
                    @click="delCover(i)"
                    class="delIcon iconfont icon-remove-1-copy"
                  ></span>
                </div>
                <div @click="opUpFile()" class="uploader">+</div>

                <fileUpload
                  ref="up"
                  v-show="false"
                  id="bgcupload"
                  accept="*"
                  typefolder="stageGoods"
                  parentfolder="material"
                  @progress="uploadProgress"
                  @checkfile="checkfile"
                  @error="uploadError"
                  @success="uploadSuccess"
                ></fileUpload>
              </div>
            </div>
            <div class="setup_box">
              <div v-if="uppro > 0 && uppro < 100">上传中 {{ uppro }}%</div>
            </div>
          </div>
        </div>
      </div>
      <template v-slot:footer>
        <div class="save">
          <span @click="saveScene" class="confirmbtn">保存商品</span>
        </div>
        <!-- <button @click="visible = false">取消</button> -->
      </template>
    </TDialog>
    <!-- 设置问题弹窗 -->
    <TDialog
      top="0"
      :visible.sync="questionShow"
      width="45%"
      title="设置问题"
      @close="cancel"
    >
      <!-- 使用v-slot指定插槽进行编辑 -->
      <div class="add-box addform_box">
        <div class="add-content">
          <!-- <div class="setup_content" @focusout="validate"> -->
          <div class="setup_content">
            <div class="setup_box">
              <div class="setup_lable">问题:</div>
              <div class="setup_block">
                <input
                  style="width: 400px"
                  v-model.trim="questionDetail.questionName"
                  type="text"
                  placeholder="请输入问题"
                />
              </div>
            </div>
            <div class="setup_box">
              <div class="setup_lable">回答:</div>
              <div class="setup_block">
                <textarea
                  v-model="questionDetail.questionAnswer"
                  class="longText"
                  style="resize: none"
                  rows="4"
                  maxlength="250"
                ></textarea>
              </div>
            </div>
            <div class="setup_box">
              <div class="setup_lable">绑定商品(选填):</div>
              <div class="setup_block">
                <!-- {{ selectGoodsShow ? "关闭选择商品" : "打开选择商品" }} -->
                <span
                  style=""
                  @click="selectGoodsShow = !selectGoodsShow"
                  class="iconfont icon-out-column setup_btn"
                >
                </span>
              </div>
              <div
                style=""
                class="goods_wrapper"
                v-show="selectGoodsShow"
                @click.self="selectGoodsShow = false"
              >
                <div class="goodsSelect" style="">
                  <div v-if="goodsList.length == 0" style="text-align: center">
                    <br /><br />暂未添加任何商品<br />
                    请在《直播带货》中添加
                  </div>
                  <div
                    v-for="item in goodsList"
                    class="goodsQuestionList"
                    :key="item.commodityId"
                    @click="selectGoods(item)"
                    :class="{ active: isgoodsScelcet(item) }"
                  >
                    <img
                      :src="
                        spileUrl(item.productCover)
                          ? spileUrl(item.productCover)
                          : require('@/assets/images/defalut.png')
                      "
                      alt=""
                      width="66px"
                      height="66px"
                    />
                    <span>
                      {{ item.commodityName }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="setup_box" style="flex-wrap: wrap">
              <span
                style=""
                class="item_tag"
                v-for="item in commodityIdList"
                :key="item.commodityId"
              >
                {{ item.commodityName }}
                <span
                  @click="removeTag(item.commodityId)"
                  class="iconfont icon-remove-1-copy delect_tag"
                ></span
              ></span>
            </div>
          </div>
        </div>
      </div>
      <template v-slot:footer>
        <div class="save">
          <span @click="addQuestion" class="confirmbtn">保存问题</span>
          <!-- <span class="confirmbtn">保存问题</span> -->
        </div>
        <!-- <button @click="visible = false">取消</button> -->
      </template>
    </TDialog>

    <!-- 背景改为场景选择器 -->
    <div class="selector_box" v-if="selector_scene_show">
      <div class="selector_box_content">
        <TabScene @selector="selector"></TabScene>
        <div class="selector_box_close" @click="selector_scene_show = false">
          <i class="iconfont icon-guanbi"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validate, getRole, localData, timeFormat, repUrl, uuid, dataURLtoBlob, blobToFile, upImgAvatar } from '@/components/util/util_fun.js'
import { ws } from '@/components/ws/ws.js'
import { t9oss } from '@/components/util/util.js'
import { uploadFile } from '@/components/util/alioss.js'
import fileUpload from '@/components/ali_oss/alioss.vue'
import compose from '@/components/t9tts/compose.vue'
import defaultImg from '@/assets/images/mp4Icon.png'
// import { PixiCommon } from '@/components/other/PixiCommon.js'
// import { PixiPendant } from '@/components/other/PixiPendant.js'
// import PendantSelector from '@/views/selector/pendantSelector.vue'
import draggable from 'vuedraggable'
import VueSlider from 'vue-slider-component'
import dragscroll from '@/components/directive/dragscroll'
import { T9Video } from '@/components/video/t9video.js'
import Schema from 'async-validator' // 表单验证组件
import { xbot } from '@/components/xbot/xbot.js'
import { pinyin } from 'pinyin-pro'
import dayjs from 'dayjs'
import ToggleSwitch from '@/components/v-switch/index.vue'
import pagination from '@/components/pagination/index.vue'
import Scene from "@/components/scene/index"
const rules = {
  commodityName: { required: true, message: '请输入商品名' },
  // commodityPrice: { required: true, pattern: /^[0-9]+(.[0-9]{1,2})?$/, message: '请输入正确商品价格,小数支持两位' },
  commodityPrice: { required: true, message: '请输入商品价格描述' },
  commodityCommentary: { required: true, message: '请输入商品解说词' },


}
const validator = new Schema(rules)
import t9ruler from '@/components/timelineMange/component/t9ruler'//刻度尺组件
export default {
  name: 'AiLive',
  components: {
    // 'cs-ruler': ruler.CsingRuler,
    t9ruler,
    ToggleSwitch,
    pagination,// 分页组件
    Scene,
    compose, //语音合成
    fileUpload,//上传组件
    VueSlider,
    draggable,
    // TabTime: () => import('@/components/timelineMange/index.vue'),
    TabScene: () => import(/*webpackChunkName:"TabScene"*/'@/views/setup/TabScene.vue'),
    TabScene: () => import(/*webpackChunkName:"TabScene"*/'@/views/setup/TabScene.vue'),
    PendantSelector: () => import(/*webpackChunkName:"PendantSelector"*/'@/views/selector/PendantSelector.vue'),
    // setScenes: () => import(/*webpackChunkName:"setScene"*/'./components/setScene.vue'),
    // 商品组件与字幕组件
    TabCommodity: () => import(/*webpackChunkName:"TabCommodity"*/'@/views/role/menu/TabCommodity.vue'),
    TabSubtitle: () => import(/*webpackChunkName:"TabCommodity"*/'@/views/role/menu/TabSubtitle.vue'),
  },
  data () {
    return {
      t9render,
      uppro: 0,//上传进度
      Pagination: {
        //分页
        pageIndex: 1,
        pageSize: 9,
        totalCount: 1,
        pageCount: 0
      },
      getHistoryParam: {// 获取历史脚本参数
        userId: this.$store.state.userinfo.userId,
        sort: 0,
        pageIndex: 0,
        pageSize: 9
      },
      changeOver: true, // 用于点击历史脚本等操作切换时更新角色编辑信息
      autoUser: null, // 当前场景的角色
      chattext: "",//聊天输入框内容
      chatshow: false,//聊天框显示
      chatboting: false,//聊天思考中
      chatbot: null,//聊天机器人
      electron: false,//是否是客户端
      autochat: true,//是否自动会话

      qalist: [
        // {
        //     q:"今天你吃饭了吗？",
        //     a:"没有，我在睡觉",
        //     source:"AI",//来源，AI,人工,语料库
        //     state:2,//0未回答，1队列中，2已回答
        // }
      ],//问答列表
      LiverUrl: "",//直播地址
      opLiveing: false,//是否正在直播监听

      // ----------------------------机器人相关---------------------------------
      shuxing: false,
      setSceneShow: false, //设置场景组件弹窗
      // selector_history: false,// 历史脚本弹窗
      actionLoading: false,// 生成脚本loading组件
      sceneId: '',// 场景id
      selector_scene_show: false, // 场景选择器是否显示
      t9video: null,//t9video对象 在当前组件中是脚本对象
      tab: 0,
      Jtab: 0,
      autoplay: false,//是否开启自动播放
      scenesindex: -1,//正在播放的位置，自动播放到第几个了
      isplayingSpeekId: '',//正在播放句子的id
      isplayingGoodId: '',//正在播放商品的id
      // ttslist:[],
      visible: false,//语音合成测试界面
      guajiansel: false,//挂件选择器
      tl: null,//TimelineLite进度条
      jindutiao: 0,//播放进度条
      alltime: "00:00",//总时长
      scenes: 0,//当前播放的场景
      res_index: 0,//当前播放的资源
      resid: "",//当前播放的资源id
      progressshow: false,//进度条显示
      duration: 0,//视频总时长
      dur: 0,
      zijindus: [],//子进度条对象
      gaile: false,//是否修改了内容，需要重构进度条
      menu: 0,// 当前选择的元素restype类型
      // ------商品相关参数
      goodsShow: false,// 商品弹窗控制
      questionShow: false,// 问题弹窗
      selectGoodsShow: false,// 问题选择商品弹窗
      goodsList: [],// 商品列表
      historyScript: [],// 历史脚本
      historyIdActive: '',// 当前选中的历史脚本id
      questionList: [],// 常见问题列表
      goodDetail: { // 商品详情
        commodityName: '',// 商品名称
        commodityCommentary: '',//商品解说词
        commodityInterpretationType: 1,	// 商品解说类型 1.文本词解说 2.音频解说 3.视频解说
        productCover: [],	// 商品封面
        mediaPath: '', //解说音频/视频地址
        commodityPrice: '',// 商品价格
        commodityNumber: '',// 商品编号
        commodityId: '',//商品id
      },
      questionDetail: {
        questionName: '',
        questionAnswer: '',
        commodityId: [],// 	商品id
        type: 1,// 类型 1.商品
      },
      validatorControl: {}, // 验证control
      isSel: false,
      allChecked: false, // 是否全选
      checkedIds: [], // 已选择的商品id(整个商品)
      ws: null,
      istimeing: false,//是否正在生成播放时间轴中
    }
  },
  watch: {
    checkedIds (newValue, oldValue) { // 全选操作

      if (this.checkedIds.length == this.goodsList.length) {
        this.allChecked = true
      } else {
        this.allChecked = false
      }
      // console.log(this.checkedIds)
    },
    activeSel (newValue, oldValue) { // 切换'脚本'与'会话'时将tab选中第一项
      this.tab = 0
    },


  },
  watch: {
    // 此处监听的是窗口模式的改变,重新生成timeline
    't9render.pattern' (item1, item2) {
      console.log('此处监听的是窗口模式的改变t9renderer监听参数i', item1, item2)
      // 只需要把播放按钮改重新初始
      this.setScene()
      this.gaile = true
    },
    deep: true
  },
  inject: { // 接收祖先组件的传值
    AppMain: { //appmian.vue的实例对象
      //函数式组件取值不一样
      default: () => ({})
    }
  },

  methods: {
    rulerNum (value) {
      this.NumValue = value
      console.log(value, '选中值value')
    },
    endEvent (val) {
      console.log('结束', val)
    },
    startEvent (val) {
      console.log('开始', val)
    },

    openTime () {

    },
    dongtai (back) {
      let name = back.toLowerCase().substring(back.lastIndexOf('.') + 1)
      if (name == "mov" || name == "ogg" || name == "mp4") {
        return "动态"
      }
      else {
        return ""
      }

    },
    changeTab (active) {
      if (this.istimeing) {
        return this.$message.warning('请等待渲染器场景加载完成')
      } else {
        this.tab = active

      }
    },
    saveLiverUrl () {
      // localData("set", "LiverUrl", 'https://live.douyin.com/642344273903')
      localData("set", "LiverUrl", this.LiverUrl)
      this.$message.success('直播间切换成功')
    },
    /**
     * 发送聊天内容
     */
    chatsend () {
      var msg = this.chattext
      if (msg == "") {
        return
      }
      else {
        this.chatboting = true//思考中
        this.chatbot.auto = this.autochat
        this.chatbot.questions(msg, this.autoUser, t9render).then((data) => {
          // console.log(data);
          if (!this.chongfu(data)) {//重复问题过滤
            data.id = uuid()
            this.qalist.unshift(data)
            this.queuepush(data)

          }
          else {
            this.$message.warning("重复问题过滤")
          }
          this.chatboting = false//思考结束
          this.chattext = ""
        })

      }

    },
    // 断开连接ws
    disconnect () {
      // console.log(this.AppMain.ws)
      // this.AppMain.ws.socket.ws.close()
      this.AppMain.closeWs()
      this.$message.warning('正在关闭连接')
      this.opLiveing = false//直播状态
      this.qalist = []
    },
    //开启直播监听
    livestart () {
      if (!this.LiverUrl) {// 没有直播将地址,打开输入地址弹窗
        return this.$message.warning('请输入直播地址')
      }
      this.AppMain.connectMode(this.LiverUrl)
      this.$message.warning('直播间连接中...')
      this.opLiveing = true//直播中

      console.log('会话页面接收的ws', this.AppMain.ws)


    },
    /**
     * 新增QA集合
     */
    addqalist (qaobj) {
      // console.log('auto页面新增QA集合', qaobj)
      if (!this.opLiveing) {
        this.opLiveing = true//直播中
      }

      if (qaobj.q == "" || qaobj.q == undefined) {
        qaobj.q = this.chattext
      }

      this.chatbot.auto = this.autochat
      this.chatbot.liveanswer(qaobj.q, this.autoUser).then((data) => {
        // console.log('新增QA集合返回', data)
        // console.log(data);
        if (JSON.stringify(data) != '{}') {
          if (!this.chongfu(data)) {//重复问题过滤
            data.id = uuid()
            this.qalist.unshift(data)
            this.queuepush(data)
          }
          else {
            // console.log("重复问题")
          }

        }
      })
      // this.qalist.unshift(qaobj);
    },
    /**
     * 重复问题过滤
     */
    chongfu (qaobj) {
      var flag = false
      this.qalist.forEach((item, index) => {
        // console.log(item.q,qaobj.q);
        if (item.q == qaobj.q) {
          flag = true
        }
      })
      return flag
    },
    /**
     * 将QA插入讲述队列
     */
    queuepush (data) {
      if (data.a != "") { //将有回答内容的插入队列
        //将问答，转为语音话术
        this.chatbot.qa2tts(data, this.autoUser).then((ttsdata) => {
          t9render.runfunction("t9tl.queuepush", [ttsdata])
        })
      }
    },
    //自动开启(开启聊天机器人)
    switchOuto () {
      this.autochat = !this.autochat
    },
    // ----------------------------机器人相关---------------------------------
    editTts (resobj, tts) { //修改单句语音
      // console.log('需要编辑的语音', tts)
      this.$refs.Scene.editTts(resobj, tts)
    },
    errorImg (e) {
      const img = e.srcElement
      img.src = defaultImg
      img.onerror = null // 防止闪图
    },
    showSceneChange () {
      this.selector_scene_show = !this.selector_scene_show
    },
    cleanLocal () {
      localData('clean', "ttslist-new")
    },
    setT9video (obj) {
      // console.log('子组件调用的setT9video方法传输scene对象', obj)
      this.$set(this.t9video.videoobj.scenes, 0, obj)
      this.localDatasave(1)
    },
    cancelSetScene () { // 关闭场景组件弹窗
      // console.log('关闭场景父组件弹窗')
      this.setSceneShow = false

    },
    getscens (obj) {
      console.log('ai控页面接收渲染器传的值', obj)
      this.$set(this.t9video.videoobj.scenes, 0, obj)
      this.localDatasave(2)
      if (this.$refs.tabCommodity) {
        this.$refs.tabCommodity.transfrom()

      }
    },
    setScene (obj) {
      if (obj) {
        // console.log('子组件调用的setScene方法', obj)
        this.t9video.videoobj.scenes[0] = obj
        window.t9render.setScene(this.t9video.videoobj.scenes[0])
      } else {
        // console.log('auto组件调用的setScene方法')
        window.t9render.setScene(this.t9video.videoobj.scenes[0])
      }
    },

    spileUrl (data) {
      return data.split(',')[0]
    },
    // 切换模板方法相关方法
    selector (sid) {
      this.$confirm({
        title: "操作提示",
        type: "warning",
        message: '切换场景模板将会清除以生成的语音脚本,确认切换吗?'
      }).then(() => {
        this.changeOver = false
        console.log('选择内容模板id', sid)
        // 切换模板清除vuex中保存的历史脚本id
        this.$store.commit('setHistoryIdActive', '')
        this.historyIdActive = ''
        if (sid == '') {
          localData('clean', "ttslist-new")
          this.t9video = new T9Video()
          this.$nextTick(() => {  // 解决切换场景模板时角色信息没有切换问题
            // console.log('触发scene组件的v-if')
            this.changeOver = true
          })
          // console.log('初始化的t9video', this.t9video.videoobj)
          this.dur = 0
          // this.t9video.videoobj.scenes[0].scene.gradient = 'background:radial-gradient(circle,#3b424a, #171c1c 67%)'
          this.t9video.videoobj.scenes[0].scene.type = 'transparent'
          let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
          // console.log('当前角色的索引', roleIndex)
          this.menu = 0

          if (roleIndex != -1) {
          } else {
            // if (this.autoUser) {
            this.t9video.videoobj.scenes[0].res.push({
              resid: this.autoUser.rolesId,
              resname: this.autoUser.rolesName,
              resobj: this.autoUser,
              resimg: this.autoUser.rolesPhoto,//资源封面 
              restype: 1,
              startend: [0, 0],
              timeline: []
            })
          }
          this.setScene()
          this.localDatasave()
          // t9render.runfunction("t9tl.tlstop", [])
          this.stop()
          // this.timelineto()
          // this.gaile = true

        } else {
          if (sid.length === 1) {
            this.get('/vup/static/config/scenes.json').then((res) => {
              console.log('获取到的场景模板', res.data)
              res.data.forEach(item => {
                if (item.sceneId === sid) {
                  console.log('选择的模板', item)
                  this.$set(this.t9video.videoobj.scenes, 0, item)
                  // window.t9render.setScene(this.t9video.videoobj.scenes[0])
                  // console.log('数据也存本地', this.t9video.videoobj.scenes[0])
                  this.localDatasave()
                  // this.gaile = true
                  // t9render.runfunction("t9tl.tlstop", [])
                  this.stop()
                  this.setScene()
                  // this.timelineto()
                  this.$nextTick(() => {  // 解决切换场景模板时角色信息没有切换问题
                    // console.log('触发scene组件的v-if')
                    this.changeOver = true
                  })
                  this.selelement(this.t9video.videoobj.scenes[0].res[0], 0)
                }
              })
            })

          } else {
            this.post("/scene/getSceneInfo", { code: sid }).then((res) => {
              // console.log('获取到的场景信息', res.data)
              res.data.sceneDetails = JSON.parse(res.data.sceneDetails)
              res.data.sceneDetails.sceneId = res.data.sceneId
              // this.t9video.videoobj.scenes.splice(0, 1, res.data.sceneDetails)
              this.$set(this.t9video.videoobj.scenes, 0, res.data.sceneDetails)
              // console.log('this.tts.tts', this.t9video.videoobj)
              this.localDatasave()
              // this.gaile = true
              // t9render.runfunction("t9tl.tlstop", [])
              this.stop()
              // this.timelineto()
              this.setScene()
              this.$nextTick(() => {  // 解决切换场景模板时角色信息没有切换问题
                // console.log('触发scene组件的v-if')
                this.changeOver = true
              })

            }).catch((fail) => { })
          }

        }

        this.selector_scene_show = false
      }).catch(() => {
        // this.selector_scene_show = false
      })

    },
    // 选择商品后生成脚本方法
    getJs () {
      if (this.checkedIds.length == 0) {
        this.$message.error('请选择商品')
        return
      }
      this.stop()
      this.actionLoading = true
      this.$message.warning('生成脚本中,请耐心的等待...')

      // 配音员id
      // 查询数组this.t9video.scenes[0].res中restype==1的资源
      let roleIndex = -1 //角色中res中的索引
      let goodsIndex = -1 //商品组件中res中的索引
      let ridobj = this.t9video.videoobj.scenes[0].res.filter((item, i) => {
        if (item.restype == 1) {
          roleIndex = i
          this.t9video.videoobj.scenes[0].res[roleIndex].timeline = []
          return item
        }
      })


      let gooddsobj = this.t9video.videoobj.scenes[0].res.filter((item, i) => {
        if (item.restype == 3) {
          goodsIndex = i
          this.t9video.videoobj.scenes[0].res[goodsIndex].timeline = []
          return item
        }
      })

      let rid = null
      let language = '普通话'
      // console.log('ridobj', ridobj[0].resobj.tts)
      // return
      if (ridobj[0].resobj.tts != undefined && ridobj[0].resobj.tts != null) {
        rid = JSON.parse((ridobj[0].resobj.tts)) ? JSON.parse((ridobj[0].resobj.tts)).id : null
        language = JSON.parse((ridobj[0].resobj.tts)).language
      }
      // 将this.checkedIds中的commodityId映射到arr
      let arr = this.checkedIds.map(item => {
        return item.commodityId
      })










      this.post('/commodity/saveDubbing', { commodityIds: arr, language, rid: rid }).then(res => {
        if (res.status === 200) {
          //第一版
          // 将返回的数组下前两项插入到第三项的clid中,并以第三项的id为pid
          // let newArr = []
          // res.data.forEach(item => {
          //   if (item.type == 1 || item.type == 2 || item.type == 3) { // 判断的是开场白,过渡词等
          //     newArr.push(item)
          //   } else {
          //     // item.typeId  // 商品介绍词的id
          //     // item.children // 商品介绍词的子集
          //     newArr.forEach(citem => {
          //       citem.pid = item.typeId
          //       item.children = []
          //       item.children.push(citem)
          //     })
          //     newArr = []
          //   }
          // })
          // console.log('newArr', newArr)
          // console.log('res.data', res.data)
          // return

          // console.log('生成配音', res.data)
          // let dur = 0 // 记录串场词的时长
          // // type=2 开场白  type=4 商品引导词:我们先来看下，第一款商品《秋夜雪》  type=3 闲白串场词
          // for (let j = 0; j < res.data.length; j++) {
          //   if (res.data[j].type == 1 || res.data[j].type == '' || res.data[j].type == undefined) {
          //     // 商品中的介绍词
          //     this.t9video.videoobj.scenes[0].res[roleIndex].timeline.push(this.transRole(res.data[j], j))
          //     if (goodsIndex > -1) {
          //       this.t9video.videoobj.scenes[0].res[goodsIndex].timeline.push(this.transGoods(res.data[j], dur))
          //     }
          //     dur = 0
          //   } else {

          //     // dur += parseFloat(res.data[j].duration) + 1
          //     dur += parseFloat(res.data[j].duration)
          //     this.t9video.videoobj.scenes[0].res[roleIndex].timeline.push(this.transRole(res.data[j], j))
          //   }
          // }

          // 处理数据的

          let daArr = []
          // 第二版
          res.data.forEach((item, i) => {
            if (item.type == undefined || item.type == 1) {
              // 1.首先先给商品介绍新增一个数组存储跟该商品相关的所有话术
              let copy = JSON.parse(JSON.stringify(item))
              copy.childList = []
              daArr.push(copy)
            }
          })
          // console.log('先循环得到所有的商品介绍词数组daArr', daArr)
          // daArr = [{typeid:1,childList:[]},{typeid:3,childList:[]},{typeid:2,childList:[]}]
          let i = 0
          // 2.给每句话绑定一个pid  pid为商品的id,
          res.data.forEach(item => {
            if (item.type == 2 || item.type == 3 || item.type == 4) { // 闲白
              item.pid = daArr[i].typeId
              daArr[i].childList.push(item)
            } else { //商品介绍词
              item.pid = daArr[i].typeId
              daArr[i].childList.push(item)
              i = i + 1
            }
          })

          // 处理后的daArr数组结构为
          // daArr=[{
          // childList: (3) [{…}, {…}, {…}, __ob__: Observer] 
          // duration: "25.128"  // 商品的整体时长 ,  主要修改的属性
          // mediaPath: "/audio/tts/1547517415326355456/1547521651237851136.mp3" // 用不到暂时,因为childList中也包含当前商品的介绍词
          // typeId: "1547517415326355456" // 商品的id
          // typeName: "水龙吟" // 商品展示名称
          // },{}

          //] 

          // childList = [   // daArr下面每一项的childList数组
          //   {
          //     "id": "655",
          //     "dubbingCode": "siyue",
          //     "typeId": "4",
          //     "type": "2",
          //     "typeName": "你们好，欢迎来到主播直播间，我是一名新手主播，感谢大家能够进入我的直播间，相见即是缘分，作为新手有很多做的不够好的地方，希望大家见谅，你们将是我在直播路上的指明灯，希望各位能多多支持我关注我。",
          //     "mediaPath": "/audio/tts/siyue/1547521665045499904.mp3",
          //     "duration": "16.812",
          //     "pid": "1547517415326355456"
          //   },
          //   {
          //     "typeId": "17",
          //     "mediaPath": "/audio/tts/siyue/1547525723655376896.mp3",
          //     "dubbingCode": "siyue",
          //     "typeName": "我们先来看下，第一款商品《水龙吟》。",
          //     "type": 4,
          //     "duration": 2.7,
          //     "pid": "1547517415326355456"
          //   },
          //   {
          //     "typeId": "1547517415326355456",
          //     "typeName": "水龙吟",
          //     "mediaPath": "/audio/tts/1547517415326355456/1547521651237851136.mp3",
          //     "duration": "25.128",
          //     "pid": "1547517415326355456"
          //   }
          // ]


          // console.log('处理后的childList数组', daArr)


          for (let i = 0; i < daArr.length; i++) {
            let dur = 0
            for (let j = 0; j < daArr[i].childList.length; j++) {
              let item = daArr[i].childList[j]
              // console.log('childList', item)
              if (item.type) {
                dur += parseFloat(item.duration)
                this.t9video.videoobj.scenes[0].res[roleIndex].timeline.push(this.transRole(item))
              } else {
                this.t9video.videoobj.scenes[0].res[roleIndex].timeline.push(this.transRole(item))
                if (goodsIndex > -1) {
                  this.t9video.videoobj.scenes[0].res[goodsIndex].timeline.push(this.transGoods2(daArr[i], dur))
                }
                // dur = 0
              }
            }

          }
          this.$set(this.t9video.videoobj.scenes, 0, this.t9video.videoobj.scenes[0])
          this.timelineto()//初始化进度条
          // console.log('当前的timeline', this.t9video.videoobj.scenes[0].res)
          this.$message.success('生成脚本成功', this.t9video.videoobj.scenes[0])

          this.tab = 0// 跳转到ai播报
          // 选中角色
          this.selelement(this.t9video.videoobj.scenes[0].res[roleIndex], roleIndex)

          this.localDatasave()
          this.saveVideo()
          this.actionLoading = false
        }
      }).catch(err => {
        console.log('生成配音失败', err)
        this.$message.error('生成脚本失败')
        this.actionLoading = false
      })




    },
    // 返回格式化的商品组件(第一版)
    transGoods (timel1, dur) {
      let good = {}
      for (let i = 0; i < this.checkedIds.length; i++) {
        if (this.checkedIds[i].commodityId == timel1.typeId) {
          good = {
            type: 4, //4:商品组件
            // id: uuid(),
            id: timel1.typeId,
            // 后端返回的时间(为了让商品组件与角色的商品介绍词符合,商品组件多停留3秒,防止没说完就切换下一个商品)
            dur: parseFloat(timel1.duration) + dur + 3,
            // dur: parseFloat(timel1.duration) + dur, // 后端返回的时间
            textname: this.checkedIds[i].commodityName,
            textprice: this.checkedIds[i].commodityPrice,
            textnum: this.checkedIds[i].commodityNumber,
            textimg: this.checkedIds[i].productCover
          }
          break
        }
      }
      return good
    },
    // 返回格式化的商品组件(第二版)
    transGoods2 (timel1, dur) {
      let good = {}
      for (let i = 0; i < this.checkedIds.length; i++) {
        if (this.checkedIds[i].commodityId == timel1.typeId) {
          good = {
            childList: timel1.childList,
            type: 4, //4:商品组件
            // id: uuid(),
            id: timel1.typeId,
            // 后端返回的时间(为了让商品组件与角色的商品介绍词符合,商品组件多停留3秒,防止没说完就切换下一个商品)
            dur: parseFloat(timel1.duration) + dur + 3,
            // dur: parseFloat(timel1.duration) + dur, // 后端返回的时间
            textname: this.checkedIds[i].commodityName,
            textprice: this.checkedIds[i].commodityPrice,
            textnum: this.checkedIds[i].commodityNumber,
            textimg: this.checkedIds[i].productCover
          }
          break
        }
      }
      return good
    },
    // 返回格式化的角色组件
    transRole (timel2, i) {
      // console.log('transRole-timel2', timel2)
      let animArr = [
        { loop: true, materialId: "1547465863152668672", materialPath: "https://f1.t-9.cn/stageFbx/material/1657779584534.fbx" },//说话.fbx
        { loop: true, materialId: "1547472634403491840", materialPath: "https://f1.t-9.cn/stageFbx/material/1657781195389.fbx" },//介绍动作.FBX
        { loop: true, materialId: "1547472676237479936", materialPath: "https://f1.t-9.cn/stageFbx/material/1657781208956.fbx" },//侧身介绍.FBX
      ]
      // loop 是否循环播放
      let role = {}
      if (timel2.type == 1 || timel2.type == "" || timel2.type == undefined) {
        for (let i = 0; i < this.checkedIds.length; i++) {
          if (this.checkedIds[i].commodityId == timel2.typeId) {
            role = {
              // 商品介绍词/ 闲聊
              id: uuid(),
              pid: timel2.pid,
              // anim: { loop: false, materialId: "1531215945857634304", materialPath: "https://f1.t-9.cn/stageFbx/material/1653905297296.fbx" },
              // 0-2随机数
              anim: animArr[Math.floor(Math.random() * 3)],
              // dur: parseFloat(timel2.duration) + 1,
              dur: parseFloat(timel2.duration),
              kx: this.pinyin2mouth(this.checkedIds[i].commodityCommentary),
              text: this.checkedIds[i].commodityCommentary,//介绍词
              tts: timel2.mediaPath,// 音频url
              type: 1,//1:说话
            }
            break
          }
        }
      } else {
        // let anim = {}
        // if (i == 0) {
        //   // console.log('开场白' + i + '句')
        //   // 打招呼/大臂
        //   anim = { loop: false, materialId: "1516749819039846400", materialPath: "https://f1.t-9.cn/stageFbx/material/1650456301645.fbx" }

        // } else {
        //   // 礼仪站姿
        //   // console.log('串场词第' + i + '句')
        //   anim = { loop: true, materialId: "1522157191291867136", materialPath: "https://f1.t-9.cn/stageFbx/material/1651745521663.vmd" }
        // }
        role = {
          // 开场白与串场词
          // anim: anim,
          anim: animArr[Math.floor(Math.random() * 3)],
          id: uuid(),
          pid: timel2.pid,
          // dur: parseFloat(timel2.duration) + 1,
          dur: parseFloat(timel2.duration),
          kx: this.pinyin2mouth(timel2.typeName),
          text: timel2.typeName,//介绍词
          tts: timel2.mediaPath,// 音频url
          type: 1,//1:说话
        }
      }

      return role
    },
    /**
   * 通过对文本分析，获得口型集合
   */
    pinyin2mouth (text) {
      var mouth = []
      //将文本中的韵母拆出
      var yunmu = pinyin(text, { pattern: 'final', toneType: 'none', type: 'array' })
      // var shengmu = pinyin(text,{ pattern: 'initial', toneType: 'none', type: 'array' }); 
      // console.log("哈哈",yunmu);
      //根据韵母发音不同，对照进入5个原因口型
      var pipeibiao = {
        A: ["a", "an", "ia", 'ang', "2", "8"],//啊的因，大开
        E: ["i", "e", "ei", "ie", "en", "er", "eng", "1", "7"],//依的因，闭合拉宽
        I: ["ai", 'in', "ing", "3", "4", "0"],//和E差不多
        O: [],
        U: ["o", "ao", 'ui', "iao", "ong", "u", "ü", "üe", "ou", 'un', "uan", "ün", "5", "6", "9"]//优的因，嘟嘴
      }
      // var shengmubiao ={
      //     E:["z","c","s","y"],
      //     U:["w","r","zh","ch","sh"]
      // }
      for (var i = 0; i < yunmu.length; i++) {
        //插入声母口型
        // var zhaodao1 = false;
        // for(var key in shengmubiao){
        //     if(shengmubiao[key].indexOf(shengmu[i]) >=0)
        //     {
        //         mouth.push(key); //未识别口型
        //         zhaodao1 = true;
        //         break;
        //     }
        // }
        // if(!zhaodao1) //未识别口型，和闭口音
        // {
        //     mouth.push("O"); //未识别口型
        // }

        //插入韵母口型
        var zhaodao = false
        for (var key in pipeibiao) {
          if (pipeibiao[key].indexOf(yunmu[i]) >= 0) {
            mouth.push(key) //未识别口型
            zhaodao = true
            break
          }
        }
        if (!zhaodao) //未识别口型，和闭口音
        {
          mouth.push("O") //未识别口型
        }
      }
      return mouth
      // console.log(yunmu,this.mouth);
    },
    // mounted 初始化control
    validatorInit () {
      for (const key in rules) {
        // control 属性对应rules，v-if 对应 false 与 message（message不应为空）
        this.$set(this.validatorControl, key, false)
      }
      // console.log(this.validatorControl)
    },
    validate (e) { // 验证
      const control = this.validatorControl

      if (e) {
        // 验证单个元素
        // 验证input添加prop属性（如下面input所示）
        const prop = e.target?.attributes?.prop?.value
        if (!prop) return
        // 清理control
        control[prop] = false
        validator.validate(this.goodDetail, (errors, fields) => {
          if (errors && fields[prop]) control[prop] = fields[prop][0].message
        })
      } else {
        // 验证整个元素
        for (const key in control) {
          control[key] = false
        }
        // async-validator 是异步返回，所以需要Promise传递结果
        return new Promise((resolve, reject) => {
          validator.validate(this.goodDetail, (errors, fields) => {
            if (errors)
              errors.forEach(item => {
                this.validatorControl[item.field] = item.message
              })
            else resolve(true)
            resolve(false)
          })
        })
      }
    },


    getQuestionList () { // 获取题目列表
      // console.log('getQuestionList')
      this.post('/question/findQuestionList', { searchText: '', pageIndex: 0, pageSize: 99 }).then((res) => {
        // console.log('常见问题', res)
        this.questionList = res.data[0]
        res.data[0].forEach((item) => {
          this.chatbot.QAlist.push({
            question: item.questionName,
            answer: item.questionAnswer,
          })
        })

        let totle = res.data[1]
      })
    },
    addQuestion () { // 添加题目
      if (this.questionDetail.questionName == '') {
        this.$message({
          message: '请输入提问的问题',
          type: 'warning'
        })
        return
      }
      if (this.questionDetail.questionAnswer == '') {
        this.$message({
          message: '请输入问题回答',
          type: 'warning'
        })
        return
      }
      if (this.questionDetail.questionId) {
        this.questionDetail.type = 1
        this.post('/question/modfiy', this.questionDetail).then((res) => {
          this.getQuestionList()
          if (res.status == 200) {
            this.$message({
              type: 'success',
              message: '修改成功'
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            })
          }
          // this.questionShow = false
          this.cancel()
        })
      } else {
        this.post('/question/save', this.questionDetail).then((res) => {
          if (res.status == 200) {
            this.$message({
              type: 'success',
              message: '添加成功'
            })
            this.getQuestionList()
          } else {
            this.$message({
              type: 'warning',
              message: res.message
            })
          }
          this.cancel()
        })
      }

    },
    questionDel (item) {// 删除题目
      this.post('/question/delete', { code: item.questionId }).then((res) => {
        // console.log('删除题目', res)
        if (res.status == 200) {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getQuestionList()
        } else {
          this.$message({
            type: 'warning',
            message: res.message
          })
        }
      })
    },
    questionEdit (item) {// 编辑题目

      this.post('/question/getQuestionInfo', { code: item.questionId }).then((res) => {
        // console.log('编辑题目', res)
        // return

        if (res.status == 200) {

          if (res.data[0].commodityId == undefined) {
            res.data[0].commodityId = []
          }
          res.data[1].forEach((item) => {
            if (item.questionId == res.data[0].questionId) {
              res.data[0].commodityId.push(item.typeId)
            }
          })
          this.questionDetail = res.data[0]
          this.questionShow = true
        } else {
          this.$message({
            type: 'warning',
            message: res.message
          })
        }
      })
    },
    isgoodsScelcet (obj) {// 商品是否已选择
      return this.questionDetail.commodityId.some((item) => item == obj.commodityId)
    },
    selectGoods (obj) { // 选择商品
      if (this.questionDetail.commodityId.some((item) => item == obj.commodityId)) {
        this.questionDetail.commodityId.splice(this.questionDetail.commodityId.indexOf(obj.commodityId), 1)
      } else {
        this.questionDetail.commodityId.push(obj.commodityId)
      }
      // console.log(this.questionDetail)

    },
    removeTag (id) {//删除已选商品标签
      this.questionDetail.commodityId.splice(this.questionDetail.commodityId.indexOf(id), 1)
    },

    // 历史脚本相关S--------------------------------------------
    getHistoryScript (cb) { // 获取历史脚本
      this.actionLoading = true

      let json = JSON.stringify(this.t9video.videoobj.scenes[0])
      // console.log('json', json)
      // this.historyScript 
      this.post('/video/list', this.getHistoryParam).then((res) => {
        this.Pagination.totalCount = res.data[1]
        this.Pagination.pageCount = Math.ceil(this.Pagination.totalCount / this.Pagination.pageSize)
        this.historyScript = res.data[0]
        let totle = res.data[1]
        // console.log('历史播报列表', res)
        this.actionLoading = false

      }).catch((err) => {
        this.actionLoading = false
        console.log(err)
      })
      !!cb && cb()//分页用到了
    },
    // 分页
    employeePagesFn (pageIndex, cb) { //pageIndex --- 分页组件返回的页码，    cb ---- 主要目的是为分页加锁，固定参数
      let self = this
      self.Pagination.pageIndex = pageIndex
      self.getHistoryParam.pageIndex = pageIndex - 1

      self.getHistoryScript(cb)
    },
    setHistoryScene (item) { //点击历史脚本时
      // console.log('点击历史脚本时', item)
      this.changeOver = false
      // console.log('点击脚本触发cahngeobver,v-if成false  ', this.changeOver)
      if (typeof item.videoJson == 'string') {
        item.videoJson = JSON.parse(item.videoJson)
      } else {
        item.videoJson = item.videoJson
      }
      this.historyIdActive = item.videoId
      this.$store.commit('setHistoryIdActive', item.videoId)
      if (item.videoJson.scenes) { // 兼容之前的脚本
        this.$set(this.t9video, 'videoobj', item.videoJson)
      } else {
        this.$set(this.t9video.videoobj.scenes, 0, item.videoJson)
      }

      // this.$set(this.t9video.videoobj.scenes, 0, item.videoJson)
      // this.setScene()
      this.localDatasave()
      this.stop()
      this.timelineto(this.t9video.videoobj)//初始化进度条\
      // this.gaile = true
      // t9render.runfunction("t9tl.tlstop", [])
      let roleIndex = 0 //角色中res中的索引
      let ridobj = this.t9video.videoobj.scenes[0].res.filter((item, i) => {
        if (item.restype == 1) {
          roleIndex = i
          return item
        }
      })
      this.tab = 0// 跳转到ai播报
      this.$message.success("切换成功")
      // 选中角色
      this.autoUser = this.t9video.videoobj.scenes[0].res[roleIndex].resobj
      this.$nextTick(() => {
        this.changeOver = true
      })
      // this.changeOver = true
      this.selelement(this.t9video.videoobj.scenes[0].res[roleIndex], roleIndex)
    },
    delHistory (id) { // 删除历史脚本
      this.post('/video/delete', { videoId: id }).then((res) => {
        if (res.status == 200) {
          this.getHistoryScript()
          this.$message({
            type: 'success',
            message: '删除成功'
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.message
          })
        }
      })
    },
    saveVideo () { // 保存视频
      let timestamp = new Date().getTime()
      let videoName = dayjs(timestamp).format('YYYY年MM月DD日HH:mm')
      // let json = JSON.stringify(this.t9video.videoobj.scenes[0])
      let json = JSON.stringify(this.t9video.videoobj) // 保存的是整个视频对象
      t9render.screenshot(async (data) => {

        var that = this
        var newurl = '/stageImg/cover/'
        var name = newurl + "/script_cover_" + new Date().getTime() + ".png"
        let blob = await upImgAvatar(blobToFile(dataURLtoBlob(data), videoName), 300, 400)
        // console.log('blob', blob)
        uploadFile(name, blob, function (progress) {
          // uploadFile(name, dataURLtoBlob(data), function (progress) {
          // 上传进度
          // console.log("封面上传进度：" + progress)
        }, function (results) {
          var url = t9oss + results.name//results.res.requestUrls[0].split("?uploadId=")[0];
          that.post('/video/save', { keyWord: videoName, videoId: timestamp, videoName: videoName, videoJson: json, userId: that.$store.state.userinfo.userId, videoCover: url }).then((res) => {
            // console.log('保存视频的返回值', res)
            that.actionLoading = false
            that.historyIdActive = res.data.videoId
            that.$store.commit('setHistoryIdActive', res.data.videoId) //历史脚本页面的选中状态
            that.getHistoryScript()
            // this.questionList = res.data
          })
        }, function (err) {
          console.log("封面上传失败！" + err)
          that.actionLoading = false

          // that.saveCenter();
          return err
        })

      }, 'scene')
      // console.log('json', json)

    },
    editVideo () {// 编辑视频
      this.actionLoading = true
      // console.log('编辑视频的scenes', this.t9video.videoobj.scenes[0], this.historyIdActive)
      // console.log(dayjs().format('YYYY年MM月DD日HH:mm'))
      let videoName = dayjs().format('YYYY年MM月DD日HH:mm') + '(改)'
      let json = JSON.stringify(this.t9video.videoobj.scenes[0])
      t9render.screenshot(async (data) => {
        var that = this
        var newurl = '/stageImg/cover/'
        var name = newurl + "/script_cover_" + new Date().getTime() + ".png"
        let blob = await upImgAvatar(blobToFile(dataURLtoBlob(data), videoName), 300, 400)
        // console.log('blob', blob)
        uploadFile(name, blob, function (progress) {
          // uploadFile(name, dataURLtoBlob(data), function (progress) {
          // 上传进度
          // console.log("封面上传进度：" + progress)
        }, function (results) {
          var url = t9oss + results.name//results.res.requestUrls[0].split("?uploadId=")[0];
          that.post('/video/modfiy', { keyWord: videoName, videoId: that.historyIdActive, videoName: videoName, videoJson: json, userId: that.$store.state.userinfo.userId, videoCover: url }).then((res) => {
            // console.log('保存视频的返回值', res)
            that.actionLoading = false
            // that.historyIdActive = res.data.videoId
            // that.$store.commit('setHistoryIdActive', res.data.videoId)
            that.$message.success('编辑保存成功')
            that.getHistoryScript()
            // this.questionList = res.data
          })
        }, function (err) {
          console.log("封面上传失败！" + err)
          that.actionLoading = false

          // that.saveCenter();
          return err
        })

      }, 'scene')
    },
    // 历史脚本相关E--------------------------------------------

    getGoodsList () { // 获取商品列表
      this.post('/commodity/findCommodityList', {
        searchText: "",
        type: 0,
        pageIndex: 0,
        pageSize: 99
      }).then((res) => {
        // for (let i = 0; i < res.data[0].length; i++) {
        //   res.data[0][i].productCover = res.data[0][i].productCover.split(',')[0]
        // }
        this.goodsList = res.data[0]
      })
    },
    getGoodsInfo (id) {   // 获取商品详情
      this.post('/commodity/getCommodityInfo', { code: id }).then((res) => {
        res.data.productCover = res.data.productCover.split(',')
        this.goodDetail = res.data
        this.goodsShow = true // 打开弹窗回显
        // console.log('获取当前商品的详情', this.goodDetail)
      })
    },
    addGoods (id) { // 打开新增或编辑弹窗
      this.validatorInit() //验证初始化
      if (id) {
        // this.goodDetail.commodityId = id
        this.getGoodsInfo(id)
        // console.log('编辑商品')
      } else {

        this.goodsShow = true
      }
    },
    delGoods (id) { // 删除商品
      this.$confirm({
        title: "操作提示",
        type: "warning",
        message: '删除商品无法恢复,确认删除吗?'
      }).then(() => {
        this.post('/commodity/delete', { code: id }).then((res) => {
          if (res.status === 200) {
            this.$message.success('删除成功')
            this.getGoodsList()
          }
        })
      }).catch(() => {
        this.$message.info('取消删除')
      })
    },

    cancel () { //关闭商品弹窗
      this.goodsShow = false
      this.selectGoodsShow = false
      this.goodDetail = {
        commodityName: '',// 商品名称
        commodityCommentary: '',//商品解说词
        commodityInterpretationType: 1,	// 商品解说类型 1.文本词解说 2.音频解说 3.视频解说
        productCover: [],	// 商品封面
        mediaPath: '', //解说音频/视频地址
        commodityPrice: '',// 商品价格
        commodityNumber: '',// 商品编号
        commodityId: '',//商品id
      }
      this.questionShow = false
      this.questionDetail = {
        questionName: '',
        questionAnswer: '',
        commodityId: [],// 	商品id
        type: 1,// 类型 1.商品
      }
    },

    // 上传文件相关--------
    opUpFile () { // 上传商品图片/视频
      this.$refs.up.$el.click()
      // .click()
    },
    // 
    //上传失败
    uploadError (err) {
      this.uploadloading = false
      this.$message.error("上传失败！")
      // this.putLog("文件上传失败！")
      console.log(err)
    },
    //文件选择成功
    checkfile (file) {
      // console.log('选择的文件', file)
      return
      this.loglist = []
      this.uploadloading = true
      this.putLog("已选择文件：" + file.name)
      this.putLog("正在上传中...")
    },
    //进度条
    uploadProgress (progress) {
      console.log('上传进度条', progress)
      this.uppro = parseInt(progress * 100)
    },

    //上传成功！
    uploadSuccess (json) {
      console.log('素材上传成功的回调', json)
      // if (json.fileDir.length <= 0) {
      //   this.$message.error("上传文件不可用!")
      // } else {

      this.$message.success("上传成功")
      this.goodDetail.productCover.push(t9oss + '/' + repUrl(json.fileUrl))
      // console.log(this.goodDetail)

    },
    // 上传文件结束-------------------
    // selChange (res) {
    //   console.log('选框切换操作', res)
    // },
    delCover (i) {
      this.goodDetail.productCover.splice(i, 1)
    },
    async saveScene () {
      if (!(await this.validate())) return
      this.goodDetail.productCover = this.goodDetail.productCover.join(',')
      if (this.goodDetail.commodityId) {

        this.post('/commodity/modfiy', this.goodDetail).then((res) => {
          // console.log(res)
          if (res.status === 200) {
            this.$message.success('编辑成功')
            this.getGoodsList() // 重新获取列表
          }
        })
      } else {
        this.post('/commodity/save', this.goodDetail).then((res) => {
          // console.log(res)
          if (res.status === 200) {
            this.$message.success('添加成功')
            this.getGoodsList()
          }
        })
      }
      this.cancel()  // 关闭窗口 goodDetail对象初始化
    },
    changeAllChecked () { //全选操作
      if (this.allChecked) {
        this.checkedIds = this.goodsList.map(item => item)
      } else {
        this.checkedIds = []
      }
    },
    // async-validate.
    // -------------------------------------------------

    /**
     * 获得合成的内容
     */
    successcompose (obj, isEdit) {
      // console.log('合成成功', obj, '是否编辑', isEdit)
      obj.type = 1//进度条内容类型
      if (isEdit) {
        // console.log('编辑', obj)
      } else {
        this.t9video.timelinepush(this.resid, obj)
      }
      this.localDatasave()
      this.gaile = true
      t9render.runfunction("t9tl.tlstop", [])
    },
    // 获得编辑的语音内容
    successedit (obj, res_index) {
      // console.log('编辑成功', obj, res_index)
      // 通过obj.id获得索引
      let index = this.t9video.videoobj.scenes[0].res[res_index].timeline.findIndex(item => item.id === obj.id)
      if (index > -1) {
        this.t9video.videoobj.scenes[0].res[res_index].timeline[index] = obj
      }
      if (obj.pid != '' && obj.pid != null && obj.pid != undefined) {
        this.updataGoodsTime(obj.pid, obj)
      } else {
        let goodsIndex = this.t9video.videoobj.scenes[0].res.findIndex(item => item.restype === 3)

        // if (goodsIndex > -1) { // 不需要更新商品时间,
        //   this.t9video.videoobj.scenes[0].res[goodsIndex].timeline[this.t9video.videoobj.scenes[0].res[goodsIndex].timeline.length - 1].dur += obj.dur
        // }
      }
      this.gaile = true
      t9render.runfunction("t9tl.tlstop", [])
    },
    // 通过返回的商品id重新计算商品时间
    updataGoodsTime (pid, obj) { // pid : 编辑的商品id, obj: 编辑语音返回的对象,用于替换childList
      // 返回商品索引
      let goodsIndex = this.t9video.videoobj.scenes[0].res.findIndex(item => item.restype === 3)
      if (goodsIndex > -1) {
        // 返回角色索引
        let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex(item => item.restype === 1)
        let dur = 0
        this.t9video.videoobj.scenes[0].res[roleIndex].timeline.forEach(item => {
          if (item.pid === pid) {
            dur += item.dur
          }
        })
        this.t9video.videoobj.scenes[0].res[goodsIndex].timeline.forEach(item => {
          if (item.id === pid) {
            item.dur = dur
            // if (obj) {
            //   for (let i = 0; i < item.childList.length; i++) { // 替换childList中被编辑的语音
            //     if (item.childList[i].pid === pid) {
            //       item.childList[i] = obj
            //     }
            //   }
            // }
          }
        })
      }


    },
    // 新增语音
    successAdd (obj, resid) {
      // console.log('新增成功', obj, resid)
      this.t9video.timelinepush(resid, obj)
      this.gaile = true
      t9render.runfunction("t9tl.tlstop", [])
    },
    /**
     * 拖拽排序后触发
     */
    dragEnd () {

      this.localDatasave()

      this.gaile = true
    },
    /**
     * 删除
     */
    ttsdel (index, item) {
      this.$confirm({
        title: "操作提示",
        type: "warning",
        message: '删除后无法找回！是否确定删除？'
      })
        .then(() => {
          this.t9video.deletetl(this.resid, index)
          this.localDatasave()
          this.updataGoodsTime(item.pid)

          this.gaile = true
          t9render.runfunction("t9tl.tlstop", [])
          // this.stop()
        })
    },
    /**
     * 播放某段文本
     */
    ttsplay (index) {
      var tts = this.t9video.videoobj.scenes[this.scenes].res[this.res_index].timeline[index]
      // console.log('播放某段文本tts', tts)
      var res = this.t9video.videoobj.scenes[this.scenes].res[this.res_index]
      // console.log('播放某段文本res', res)
      if (tts.type == undefined || tts.type == 1) {
        this.scenesindex = index
        if (this.tl) {
          this.stop()
        }
        // console.log('播放某段文本tts', [res.resobj, tts])
        t9render.runfunction("speak", [res.resobj, tts])//正常应该传资源对象，现在传当前角色
      }
      else if (tts.type == 3) {
        this.scenesindex = index
        if (this.tl) {
          this.stop()
        }
        // console.log(tts);
        t9render.runfunction("PendantShow", [res, tts.postion])
      }
      // else if (tts.type == 4) {
      //   console.log('tts.type==4的播放')
      //   this.scenesindex = index
      //   if (this.tl) {
      //     this.stop()
      //   }

      //   t9render.runfunction("speak", [res, tts])
      // }
      else {
        console.log("不支持预览")
      }

    },
    /**
     * 开始自动播报
     */
    start () {
      // console.log('开始自动播报', this.dur)
      // if (this.dur == 0) return this.$message.error('请先生成事件脚本')
      this.autoplay = true
      t9render.runfunction("t9tl.tlplay", [])

    },
    /**
     * 修改进度条事件后，重建进度条
     */
    restart () {
      this.gaile = false
      // this.stop()
      // console.log('修改进度条事件后，重建进度条的videoobj', this.t9video.videoobj)
      this.timelineto()

      this.start()

    },
    /**
     * 停止自动播报
     */
    stop () {
      // console.log('触发stop')
      // this.scenesindex = -1;
      // setTimeout(() => {
      t9render.runfunction("t9tl.tlstop", [])
      this.autoplay = false
      // }, 300)
    },
    /**
     * 修改动画时长
     */
    durblur () {
      this.localDatasave()
      this.gaile = true
    },
    /**
     * 将数据构建并更新到进度条中
     */
    timelineto () {
      // 会同时执行渲染器的setScene方法
      // debugger
      let logobj = JSON.parse(JSON.stringify(this.t9video.videoobj))
      console.log('timelineto传值', logobj)
      this.istimeing = true // 控制tab切换是否可以点击
      t9render.timelineto(this.t9video.videoobj, (dur) => {
        this.istimeing = false
        // console.log('timelineto返回值', dur)
        let animobj = {
          "materialId": "1522157191291867136",
          "materialName": "礼仪站姿",
          "materialPath": "https://f1.t-9.cn/stageFbx/material/1651745521663.vmd",
          "materialType": "3",
          "materialSource": 2,
          "userId": "1469247744139988992",
          "materialSize": "0",
          "createDate": "2022-05-05T10:12:09.376Z",
          "modifyDate": "2022-06-22T05:47:55.276Z",
          "materialJson": null
        }
        t9render.sendmsg({ type: "playAnimation", data: animobj })



        dur = parseInt(dur)
        this.duration = Math.floor(dur)
        this.dur = dur
        this.t9video.videoobj.scenes[this.scenes].dur = this.duration

        this.alltime = timeFormat(this.duration)
        // console.log('处理后的alltime', this.alltime)
      })

      this.zijindus = []
      for (var i = 0; i < this.t9video.videoobj.scenes[this.scenes].res.length; i++)//给每个元素创建一个进度条
      {
        let res = this.t9video.videoobj.scenes[this.scenes].res[i]
        let restime = 0//计算资源总时长
        if (res.timeline) {
          for (var j = 0; j < res.timeline.length; j++) //遍历时间轴
          {
            var obj = res.timeline[j]
            if (!obj.type || obj.type == 1) //讲话
            {
              // restime += (obj.dur + 1)
              restime += obj.dur
            }
            else if (obj.type == 3) { //位置变化.
              restime += obj.dur
            }
          }
        }
        // let zjd = {
        //   startend: [//进度条选中区域
        //     res.startend[0],
        //     res.startend[1] == 0 ? (res.startend[0] + restime) : res.startend[1]
        //   ],
        // }
        // this.zijindus.push(zjd)
      }
      t9render.tlpfun = this.onUpdate
      t9render.tlPlaying = this.tlPlaying

    },
    //临时保存进度条内容
    localDatasave (a) {
      let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
      // console.log('数据存本地的值', a, this.t9video.videoobj)
      localData("set", "ttslist-new", this.t9video.videoobj)//保存结果
      this.autoUser = this.t9video.videoobj.scenes[0].res[roleIndex].resobj

      // console.log('数据村本地auto', this.t9video.videoobj)
    },
    //用于展示目前播放到第几行了
    playpshow (resid, index) {
      if (this.resid == resid) {
        this.scenesindex = index
      }
    },
    /**
     * 播放进度条
     */
    onUpdate (param) {
      if (this.gaile || !this.autoplay) {
        if (!this.autoplay) {
          this.gaile = false
          this.autoplay = true
        } else {
          this.gaile = true
        }
      }
      this.jindutiao = this.duration * param
      // console.log("播放进度条", this.jindutiao)

    },
    /**
     * 获取当前播放的句子id或切换商品
     */

    tlPlaying (param) {
      // console.log('tlPlaying', param)
      //     param= { id: "f2bfeba6-c046-419f-86d7-dca8e96f7eb4"
      // type: "speak"}
      if (param.type == "speak") {
        this.isplayingSpeekId = param.id
      }
      if (param.type == "commodity") {
        this.isplayingGoodId = param.id
      }
      // this.tlplaying = true
    },

    /**
     * 通过滑块修改进度
     */
    updateOption () {
      // var currtime = this.tl.duration() * (this.jindutiao/100);
      // this.stop()
      this.autoplay = true
      t9render.runfunction("t9tl.tlseek", [this.jindutiao])
    },
    //模块的展示时间范围(子进度条)
    zijinduOption (res, index) {

      var zjd = this.zijindus[index]
      // console.log(res,zjd);
      // res.startend = zjd.startend

      // this.timelineto();//重构进度条
      this.localDatasave()
      // console.log(this.t9video.videoobj);
      this.gaile = true
    },
    //选择了元素(-)
    selelement (thiselement, index) {
      // console.log('选择了元素', thiselement, index)
      this.res_index = index
      this.menu = thiselement.restype
      this.resid = thiselement.resid
      t9render.Scenesel(thiselement.resid)
    },
    removele (index) { //删除控制面板元素
      //如果元素已经包含了事件，就不能删除了，如果删除，需要把事件一起删除掉。
      var list = this.t9video.gettimeline(index.resid)
      if (list.length > 0) {
        this.$confirm({
          title: "操作提示",
          type: "warning",
          message: '该元素已经包含了事件,删除本元素会同步删除其相关事项（无法恢复），确定是否继续？。',
        })
          .then(() => {
            // this.t9video.deletetl_resid(index.resid);
            this.t9video.deleteres(index.resid)
            this.localDatasave()
            this.gaile = true
            t9render.runfunction("t9tl.tlstop", [])
          })
      }
      else {
        this.t9video.deleteres(index.resid)
        this.localDatasave()
        this.gaile = true
        t9render.runfunction("t9tl.tlstop", [])
      }
      this.res_index = 0
      this.menu = 0
    },
    //添加元素
    addele () {
      this.guajiansel = true
    },
    //挂件选择器
    successguajian (obj) {
      this.guajiansel = false
      if (obj) {
        // console.log(this.duration);
        this.t9video.respush(obj, 2, this.duration)
        this.res_index = this.t9video.videoobj.scenes[this.scenes].res.length - 1
        this.menu = 2
        this.resid = obj.materialId
        // this.timelineto()
        // window.t9render.setScene(this.t9video.videoobj.scenes[0])
        this.localDatasave()
        this.gaile = true
      }
    },
    //元素位置获得，并保存到时间序列中
    elementposition () {
      var res = this.t9video.videoobj.scenes[this.scenes].res[this.res_index]
      var lastpostion = this.t9video.lastpostion(res.resid)//时间轴最后的位置
      t9render.runfunction("pixicomm.getposition", [res.resid, res.restype], (thispostion) => {//获得元素当前的位置
        if (thispostion) {
          if (lastpostion) //有记录，比较是否相同，不同再记录
          {
            if (this.bijiao(lastpostion.postion, thispostion)) {
              //没变化，忽略
              this.$message.warning(res.resname + "的位置尺寸等未发生变化")
            }
            else {
              var shijia = {
                text: "记录位置与尺寸变化",
                dur: 1,
                type: 3,//进度条内容类型
                postion: thispostion,
              }//插入事件
              this.t9video.timelinepush(res.resid, shijia)
              this.localDatasave()
              this.gaile = true
              this.$message.success(res.resname + "记录成功")
            }
          }
          else //未找到记录，则直接存档
          {
            var shijian = {
              text: "记录位置与尺寸",
              postion: thispostion,
              dur: 1,
              type: 3,//进度条内容类型
            }//插入事件
            this.t9video.timelinepush(res.resid, shijian)
            this.localDatasave()
            this.gaile = true
            this.$message.success(res.resname + "记录成功")
          }
        }
      })



    },
    /**
     * 比较两个位置是否一致
     */
    bijiao (orlpostion, newpostion) {
      var flag = true
      if (newpostion.position) {
        if (orlpostion.position.x == newpostion.position.x
          && orlpostion.position.y == newpostion.position.y
          && orlpostion.position.z == newpostion.position.z) {
          // return true;
        }
        else {
          // console.log("position");
          flag = false
        }
      }
      if (newpostion.scale) {
        if (orlpostion.scale.x == newpostion.scale.x
          && orlpostion.scale.y == newpostion.scale.y
          && orlpostion.scale.z == newpostion.scale.z) {
          // return true;
        }
        else {
          // console.log("scale");
          flag = false
        }
      }
      if (newpostion.rotation) {
        if (orlpostion.rotation._x == newpostion.rotation._x
          && orlpostion.rotation._y == newpostion.rotation._y
          && orlpostion.rotation._z == newpostion.rotation._z) {
          // return true;

        }
        else {
          // console.log("rotation");
          flag = false
        }
      }

      return flag
    },


    /**
     * 用于各个组件Loading显示
     * 尽量统一都用一个，以后方便调整
     */
    t9loading (progress) {
      if (progress == 0) {
        this.modelloading = true
      }
      else if (progress == 1) {
        this.modelloading = false
      }
      else {
        this.loadTotleProgress = (progress * 100).toString().substring(0, 3)
      }
    },

    daihuo () {
      this.$message.warning("本功能仅对企业版开放")
    }
  },
  created () {
    // console.log("createdd t9render", this.t9render)
    // 验证是否过期
    var exp = validate()
    if (exp == '') {
      this.$store.commit('logout', {})
      location.href = '/vup/#/login'
      return
    }
    this.autoUser = getRole(this.$route.params.user)
    let tts = localData("get", "ttslist-new")
    if (tts) {
      // console.log('执行上一次的脚本')
      this.t9video = new T9Video(tts)


    }
    else {
      this.t9video = new T9Video()
      this.t9video.respush(this.autoUser, 1, this.duration)
      this.t9video.videoobj.scenes[0].scene.gradient = 'background:radial-gradient(circle,#3b424a, #171c1c 67%)'
      // }
    }
    this.sceneId = this.t9video.videoobj.scenes[0].sceneId
    // 如果restype为1,返回索引
    let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
    // console.log(roleIndex)
    this.selelement(this.t9video.videoobj.scenes[0].res[roleIndex], roleIndex)
    // console.log('当前角色的索引', roleIndex)
    if (this.$route.params.user) {
      var tl = this.t9video.videoobj.scenes[0].res[roleIndex]
      if (tl) {
        //无论时间线中的人物是谁，都改成当前角色
        tl.resid = this.autoUser.rolesId
        tl.resimg = this.autoUser.rolesPhoto//资源封面
        tl.resname = this.autoUser.rolesName//资源名称
        tl.resobj = this.autoUser
        delete tl.position
        delete tl.rotation
        delete tl.scale
        delete tl.opacity
      }

    }

    this.resid = this.t9video.videoobj.scenes[0].res[roleIndex].resid // 取当前元素列表的角色为选中id

    if (this.t9video.videoobj.scenes[0].res[roleIndex].timeline.length > 0) {
      this.gaile = true
      t9render.runfunction("t9tl.tlstop", [])
    } else {
      this.gaile = false
    }
    // this.timelineto()//初始化进度条

    if (!this.chatbot) {
      this.chatbot = new xbot() //初始化聊天机器人
    }

    var userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.indexOf(' electron/') > -1) {
      this.electron = true
    } else {
      this.electron = false
    }
    // 商品相关业务
    this.getGoodsList()
    this.getQuestionList()
    this.getHistoryScript()
    this.localDatasave()
    this.$nextTick(() => {
      // window.t9render.sendScens = this.getscens
    })
    if (this.$store.state.historyIdActive) { // 判断是否使用的是历史脚本
      this.historyIdActive = this.$store.state.historyIdActive
    }
    this.LiverUrl = localData("get", "LiverUrl") //获取本地保存的直播间地址
    if (this.AppMain.wa) {
      this.opLiveing = true//直播状态
    }
    this.setScene()

  },
  mounted () {
    // this.timelineto()//初始化进度条;
  },
  beforeDestroy () {
    // let tts = localData("get", "ttslist-new")
    // if (tts != null) {
    // }
    // this.localDatasave() //会导致退出登录后再保存数据
    // localData("set", "historyHodel_" + this.$store.state.userinfo.userId, this.autoUser)
    this.$store.commit('setActiveSel', '')

  },
  beforeRouteLeave (to, from, next) {
    if (this.autoplay) {
      // console.log('停止自动播放')
      this.$confirm({
        title: "操作提示",
        message: '离开后,AI播报将会停止运行,自动问答也会停止,确定要离开吗？',
      })
        .then(() => {
          t9render.modelclose()
          next()
        }).catch(() => {
          console.log('取消路由跳转')
        })
    } else {
      t9render.modelclose()
      next()
    }
  },
  computed: {
    commodityIdList () {
      return this.goodsList.filter((item) => {
        return this.questionDetail.commodityId.includes(item.commodityId) ? item.commodityName : ''
      })
    },
    activeSel () {
      // 控制是否显示ai卡片
      // console.log('是否显示ai卡片store', this.$store.state.activeSel)
      return this.$store.state.activeSel
    }

  }
}
</script>

<style lang="scss" scoped>
@import "@/style/mixin.scss";
.rolelist {
 
}
.rolelistSelf{
 height: calc(100% - 20px);
  width: 380px;
  margin: 0;
  margin-left: 60px;
  padding: 15px 10px;
  @include border_color("bordercolor");
  @include background("uibg");
}
.uibg {
}
.control_element {
  line-height: normal;
}
.img {
  @include font_color("fontcolor");
}
.active {
  border-left: 3px #f4acb7 solid;
  // margin-left: 5px;
  margin-left: 0;
  color: #f4acb7;
  // padding-left: 5px;
  padding-left: 0;
}
.goodsList {
  width: 100%;
  // height: 662px;
  height: 96%;
  // overflow-y: auto;
  border: 1px solid;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  @include border_color("bordercolor");
  @include background("uibg");
  .title {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    // margin-bottom: 10px;
  }
  .tool {
    height: 40px;
    line-height: 40px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    .btn {
      font-size: 14px;
      span {
        margin-right: 10px;
        color: #39f;
        cursor: pointer;
      }
    }
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;
    align-content: flex-start;
  }
  .goodsDetail {
    width: 30%;
    margin: 10px auto;
    overflow: hidden;
    position: relative;
    // background: #d3d3d3;
    // padding: 5px 0;
    .goodsSel {
      width: 10%;
      display: flex;
      justify-content: center;
      align-items: center;
      input {
      }
    }
    .goodsDetaildel {
      position: absolute;
      right: 10px;
      top: 10px;
      color: #fff;
      background: rgba(255, 0, 0, 0.6);
      text-align: center;
      padding: 5px;
      border-radius: 50%;
      display: none;
    }
    &:hover .goodsDetaildel {
      display: block;
    }
    .goodsDetailname {
      font-size: 12px;
      color: #666;
    }
  }
  .goodsDetail_row {
    // min-height: 75px;
    width: 100%;
    display: flex;
    align-items: center;
    align-content: center;

    .goodsImg {
      width: 20%;
      height: 90%;
      //   background: skyblue;
      border-radius: 10px 0 0 10px;
      overflow: hidden;
      margin: 5px 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        min-height: 65px;
      }
    }
    .goodsContent {
      width: 60%;
      //  background: #5aff03;
      font-size: 14px;
      color: #575757;
      padding: 0 10px;
      text-overflow: ellipsis;
      overflow: hidden;
      margin: 5px 0;
      line-height: 1.6em;
    }
    .goodsFun {
      width: 10%;

      background: #c5c1c1;
      display: flex;
      align-items: center;
      justify-content: space-around;
      span {
        color: #000;
        display: block;
        height: 33px;
        width: 33px;
        text-align: center;
        line-height: 33px;
        border-radius: 33px;
        background-color: rgba($color: #afaeae, $alpha: 0.8);
        &:hover {
          background: rgb(255, 255, 255);
          cursor: pointer;
        }
      }
      .edit_del,
      .remove {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
    }
  }
}
.setup_btn {
  font-size: 36px;
  line-height: 36px;
  color: #a7a7a7;
  cursor: pointer;
  &:hover {
    // box-shadow: 1px 1px 5px 1px #c7c7c7;
    color: #5c5c5c;
  }
}
.goods_wrapper {
  position: fixed;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  /* z-index: 99; */
  // background-color: rgba(0, 0, 0, 0.5);
  // background-color: #ffc0cb66;
  z-index: 2;
  .goodsSelect {
    border-radius: 5px;
    width: 300px;
    height: 400px;
    position: absolute;
    top: 20px;
    right: 20px;
    background: #c5c1c1;
    padding: 10px;
    overflow-y: auto;
    // @include border_color("bordercolor");
    // @include background("uibg");
    z-index: 2;
    top: 50%;
    left: 50%;
    margin-top: -280px;
    .goodsQuestionList {
      // 文本超出隐藏省略号
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 10px;
      line-height: initial;
      div {
        border-bottom: 1px solid #ddd;
        margin-top: 10px;
        cursor: pointer;
      }
      // div:last-child {
      //   border: none;
      // }
    }
  }
}

.quest_list {
  display: flex;
  .quest_editDel {
    position: absolute;
    right: -120px;
    padding: 0px 10px;
    width: 100px;
    display: flex;
    background: #e9afb8;
    height: 100%;
    justify-content: space-around;
    span {
      // width: 50%;
      // text-align: center;
      // border-radius: 30px;
      // background: #fff;
      font-size: 14px;
      &:hover {
        color: #000;
        cursor: pointer;
      }
    }
  }
  &:hover {
    .quest_editDel {
      right: 0px;
      // transform: scale(1);
      // transition: all 0.3s linear;
    }
  }
}
.item_tag {
  position: relative;
  display: inline-block;
  background: #dcdcdc;
  padding: 0 30px 0 10px;
  border-radius: 15px;
  margin-right: 10px;
  margin-bottom: 5px;
  box-sizing: border-box;
  // width: 33%;
  overflow: hidden;
  white-space: nowrap;
  max-width: 300px;
  text-overflow: ellipsis;
  .delect_tag {
    position: absolute;
    top: 5px;
    right: 10px;
    font-size: 18px;
    color: #e32525;
    background: #e1e1e1;
    // display: none;
    border: 1px solid;
    border-radius: 32px;
    line-height: 22px;
    z-index: 1;
    cursor: pointer;
    opacity: 0;
  }
  &:hover {
    // border: 1px solid #e32525;
    background: #cbcbcb;
    .delect_tag {
      // display: block;
      opacity: 1;
    }
  }
}
.save {
  padding: 20px 0;
  .confirmbtn {
    width: 120px;
    height: 38px;
    color: #fff;
    background: #f4acb7;
  }
  span {
    display: inline-block;
    cursor: pointer;
    width: 94px;
    height: 38px;
    line-height: 38px;
    border-radius: 27px;
    text-align: center;
    margin: 0 8px;
    color: #f4acb7;
    font-size: 16px;
    border: 1px solid #f4acb7;
  }
}
.setup_lable {
  margin-right: 20px;
}
.checkScene {
  height: 150px;
  width: 100px;
  background-color: #d7d7d7;
  border-radius: 10px;
  text-align: center;
  line-height: 150px;
  font-size: 55px;
  cursor: pointer;
  // 鼠标移入时，改变背景色
  transition: all 1s;
  &:hover {
    transition: all 1s;
    background: #888888;
  }
}
.add-box {
  .longText {
    resize: none;
    border-color: #ddd;
    color: #585858;
    padding: 7px 10px;
    border: 1px solid #ddd;
    border-radius: 3px;
    font-size: 16px;
    box-sizing: border-box;
    width: 400px;
  }
  .fengmian {
    .uploader {
      width: 90px;
      height: 90px;
    }
    .uploader_img {
      position: relative;

      width: 90px;
      height: 90px;
      line-height: 90px;
      margin-bottom: 10px;
      .delIcon {
        opacity: 0;
        position: absolute;
        top: 25%;
        left: 25%;
        width: 50%;
        height: 50%;
        font-size: 22px;
        line-height: 44px;
        border-radius: 44px;
        &:hover {
          opacity: 1;
          /* text-align: center; */
          // transform: scale(1.3);
          // transition: all 0.4s ease 0s;
          // -webkit-transform: scale(1.3);
          transition: visibility 0s, opacity 0.2s linear;
          background: #ff003ac2;
        }
      }
    }
  }
}
.autolist {
  .title {
    background-color: #f4f4f4;
    border-left: 3px #f4acb7 solid;
    padding: 7px;
    padding-left: 10px;
    @include background("uibg2");
  }
}
.paginationAuto {
  position: absolute;
  right: 10px;
  bottom: 44px;
}
.tab_houzhui {
  background-color: #f95f8e;
  color: #fff;
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 20px 0 20px;
  padding: 0 12px;
  font-size: 12px;
  line-height: 20px;
}
.save-liverurl {
  // 直播间url输入框
  display: flex;
  justify-content: space-between;
  // padding: 0 10px 20px 15px;
  padding: 0 5px;
  height: 30px;
  line-height: 40px;
  input {
    width: 150px;
    height: 30px;
    border: 1px solid #ddd;
    border-radius: 3px;
    padding: 0 5px;
    font-size: 12px;
  }
}

/* 奇数行 */
.timelin-hd-inner{
      height: 40px;
}
		.timeline-hd-inner:nth-child(odd){
			background: greenyellow;
		}
		/* 偶数行 */
		.timeline-hd-inner:nth-child(even){
			background: skyblue;
		}
</style>